import { filter, map } from 'lodash';

export const hasDuplicateByProperty = (arr: any[], property: string, value: string) => {
    const values = map(arr, property);
    return filter(values, v => v === value).length >= 2;
};
